import { render, staticRenderFns } from "./CommunityDetail.vue?vue&type=template&id=6405cbac&scoped=true&"
import script from "./CommunityDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDetail.vue?vue&type=style&index=0&id=6405cbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405cbac",
  null
  
)

export default component.exports